import EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import { isEnhancedLocation } from 'owa-location-persona';

/**
 * Checks if the location is a Web URL. it returns true if the location is a string location and
 * is a url that starts with http(s) or www
 */
export function isWebUrlLocation(location: EnhancedLocation): boolean {
    // URL starting with http(s) or www
    const urlRegex = /^((http[s]?:\/\/)|(www\.)?){1}[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}\b([-a-zA-Z0-9@:*%_\+.~#?&//=]*)/i;
    return !isEnhancedLocation(location.PostalAddress) && urlRegex.test(location.DisplayName);
}

export function openWebLocation(location: string) {
    return function() {
        const protocolRegex = /^http*/i;
        // if protocol is not specified (like in www.microsoft.com) we need to add // to the URL to start a new root address
        const url = protocolRegex.test(location) ? location : '//' + location;
        window.open(url, '_blank');
    };
}
